// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"833e2e60","703":"98b04510"}[chunkId] + ".chunk.js";
};